import { render, staticRenderFns } from "./TradeList.vue?vue&type=template&id=01f84237&scoped=true&"
import script from "./TradeList.vue?vue&type=script&lang=js&"
export * from "./TradeList.vue?vue&type=script&lang=js&"
import style0 from "./TradeList.vue?vue&type=style&index=0&id=01f84237&lang=scss&scoped=true&"
import style1 from "./TradeList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f84237",
  null
  
)

export default component.exports